import { render } from "./CommitList.vue?vue&type=template&id=26148c38"
import script from "./CommitList.vue?vue&type=script&lang=js"
export * from "./CommitList.vue?vue&type=script&lang=js"
script.render = render

export default script